import { Injectable } from '@angular/core';
import { UrlHelper } from "../../classes/urlHelper";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MerchantService {
    constructor(private httpClient: HttpClient) {
  }

  getMerchant(merchantId: any) {
    return this.httpClient.get<any>('api/Merchant/getMerchant?merchantId='+ merchantId);
  }

  getGrantedMerchants(merchantId) {
    return this.httpClient.get<any>('api/Merchant/getGrantedMerchants?merchantGroupIds='+ merchantId);
  }

  getGrantedMerchantsIncludingDeleted(merchantId) {
    return this.httpClient.get<any>('api/Merchant/GetGrantedMerchantsIncludingDeleted?merchantGroupIds='+ merchantId);
  }

  getGrantedMerchantGroups() {
    return this.httpClient.get<any>('api/Merchant/getGrantedMerchantGroups');
  }

  getTeamQuynhMerchantGroups() {
    return this.httpClient.get<any>('api/Merchant/getTeamQuynhMerchantGroups');
  }

  getTeamQuynhMerchants() {
    return this.httpClient.get<any>('api/Merchant/getTeamQuynhMerchants');
  }

  queryMerchants(query) {
    return this.httpClient.get('api/Merchant/queryMerchants' + new UrlHelper().parseToUrlParams(query, 'query.'));
  }

  saveMerchant(merchant: any)
  {
    return this.httpClient.post<any>('api/Merchant/saveMerchant', merchant);
  }

  setupTiktokApi(setupTiktokModel: any) {
    return this.httpClient.post<any>('api/Merchant/setupTiktokApi', setupTiktokModel);
  }

  getTeamMerchantGroups() {
    return this.httpClient.get<any>('api/Merchant/getTeamMerchantGroups');
  }

  getFullMerchantGroups() {
    return this.httpClient.get<any>('api/Merchant/getFullMerchantGroups');
  }

  createMerchantGroup(merchantGroup: { id?: string; name: string; orderSheetId?: string }) {
    // Server binds [FromBody] MerchantGroup; do not send id: "" — System.Text.Json rejects it for Guid.
    const body: { name: string; orderSheetId?: string } = { name: merchantGroup.name };
    const sheet = merchantGroup.orderSheetId?.trim();
    if (sheet) {
      body.orderSheetId = sheet;
    }
    return this.httpClient.post<any>('api/Merchant/createMerchantGroup', body);
  }

  saveAdminMerchantGroup(selectedMerchant) {
    return this.httpClient.post<any>('api/Merchant/saveAdminMerchantGroup', selectedMerchant);
  }

  searchTiktokCat(market, keyword) {
    return this.httpClient.get<any>(`api/Merchant/searchTiktokCat?market=${market}&keyword=${keyword}`);
  }

  getTiktokCategoryAttributes(merchantId, categoryId) {
    return this.httpClient.get<any>(`api/Merchant/getTiktokCategoryAttributes?merchantId=${encodeURIComponent(merchantId)}&categoryId=${encodeURIComponent(categoryId)}`);
  }

  getTiktokFlashSaleForMerchant(merchantId) {
    return this.httpClient.get<any>('api/Merchant/getTiktokFlashSaleForMerchant?merchantId=' + encodeURIComponent(merchantId));
  }

  getTiktokPushConfigsForMerchant(merchantId) {
    return this.httpClient.get<any>('api/Merchant/getTiktokPushConfigsForMerchant?merchantId=' + encodeURIComponent(merchantId));
  }

  setupTiktokFlashSale(flashSaleConfig: any) {
    return this.httpClient.post('api/Merchant/setupTiktokFlashSale', flashSaleConfig);
  }

  priorityFlashSale(id) {
    return this.httpClient.post('api/Merchant/priorityFlashSale?merchantId=' + encodeURIComponent(id), {});
  }

  savePushTiktokProductConfig(formData: any) {
    return this.httpClient.post('api/Merchant/savePushTiktokProductConfig', formData);
  }

  getTemplates(merchantId) {
    return this.httpClient.get<any>('api/Merchant/getTemplates?merchantId=' + merchantId);
  }

  addProductToAccountFromIdeal(processData: any) {
    return this.httpClient.post<any>('api/Merchant/AddProducttoAccountFromIdeal', processData);
  }

  addProductToAccountFromIdealWithFileDownload(processData: any): Observable<HttpResponse<Blob>> {
    return this.httpClient.post('api/Merchant/AddProducttoAccountFromIdeal', processData, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  getTiktokAppInfos() {
    return this.httpClient.get<any>('api/Merchant/getTiktokAppInfos');
  }

  deleteProductRequest(formData: FormData) {
    return this.httpClient.post('/api/Merchant/DeleteProductRequest', formData);
  }
}

export interface TiktokPushProductConfig {
  id?: string;
  merchantId: string;
  configName: string;
  basePrice: number;
  lowPriceConfig: number;
  categoryId: string;
  description: string;
  package: string;
  stock: number;
  templateFileLink?: string;
}
